import React from 'react';
import './VehicleResult.scss';
import RentalInputsContext from '@app/context/rental/RentalInputsContext';

const SearchForCard = ({ image, title, location, duration }) => {
  const { rentalInputs, setRentalInputs } = React.useContext(RentalInputsContext);

  const handleClick = () => {
    setRentalInputs({
      ...rentalInputs,
      photo : '',
      trip_type: 'hourly',
      product_title: title,
      trip_hours: 4,
    });

    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="search-card text-left">
      <img src={image} alt={title} className="search-card-img img-fluid rounded mb-2" />
      <h6 className="mb-1">{title}</h6>
      <p className="text-muted loaction-text small mb-1">{location} for {duration}</p>
      <p className="text-orange mb-0" onClick={handleClick} style={{ cursor: 'pointer' }}>
        Check OBV Price <span className="ml-1">→</span>
      </p>
    </div>
  );
};

export default SearchForCard;
